import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        // 16px on a phone, where anything smaller makes iOS zoom the page on
        // focus; 14px from md up, the size of every other control.
        "flex h-9 w-full rounded-md border border-input bg-card px-3 py-1.5 text-base ring-offset-background transition-colors touch:h-11 md:text-sm",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        // Tokens, not opacity — see button.tsx for what opacity measured.
        "disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground",
        // Drives the error border off the field's own validity state, so a
        // form never has to remember to pass an error class as well.
        "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
